import { memo, type MouseEventHandler } from "react";
import IcPlayerPause from "~/images/ic_player_pause.svg";
import IcPlayerPlay from "~/images/ic_player_play.svg";
import styles from "./PauseToggleButton.module.css";

interface PauseToggleButtonProps {
  paused: boolean;
  onClick: MouseEventHandler;
}

export const PauseToggleButton = memo<PauseToggleButtonProps>(
  ({ paused, onClick }) => (
    <button
      className={styles.toggle}
      type="button"
      onClick={onClick}
      onMouseUp={e => {
        e.stopPropagation();
      }}
    >
      <img alt="playback" src={paused ? IcPlayerPlay : IcPlayerPause} />
    </button>
  ),
  (prev, next) => prev.paused === next.paused,
);
